<template>
    <van-popup :show="show" position="center" :style="{ width: '85%' }" round @close="handleCancel"
        @update:show="handleUpdateShow">
        <div class="daily-limit-modal">
            <!-- 标题 -->
            <div class="modal-header">
                <text class="modal-title">每日限购</text>
            </div>

            <!-- 表单内容 -->
            <div class="modal-content">
                <div class="description">
                    学校或所在社区有售卖机可设定每日限购
                </div>

                <div class="form-container">
                    <!-- 学校每日限购瓶数 -->
                    <div class="form-item">
                        <div class="form-label">学校每日限购瓶数</div>
                        <van-field v-model="schoolLimit" type="number" placeholder="请输入学校每日限购瓶数" class="custom-field" />
                    </div>

                    <!-- 社区每日限购瓶数 -->
                    <div class="form-item">
                        <div class="form-label">社区每日限购瓶数</div>
                        <van-field v-model="communityLimit" type="number" placeholder="请输入社区每日限购瓶数" class="custom-field" />
                    </div>
                </div>

                <!-- 按钮区域 -->
                <div class="modal-actions">
                    <van-button type="default" size="large" class="cancel-btn" @click="handleCancel">
                        取消
                    </van-button>
                    <van-button type="primary" size="large" class="confirm-btn" @click="handleConfirm">
                        确认
                    </van-button>
                </div>
            </div>
        </div>
    </van-popup>
</template>

<script setup>
import { ref, watch } from 'vue'
import { Toast } from 'vant'
import { post } from '@/utils/request'

const props = defineProps({
    show: {
        type: Boolean,
        default: false
    },
    studentData: {
        type: Object,
        default: () => ({})
    }
})

const emit = defineEmits(['update:show', 'submit'])

const schoolLimit = ref(2)
const communityLimit = ref(2)

// 监听show变化，重置表单数据
watch(() => props.show, (newVal) => {
    if (newVal) {
        // 根据studentData设置默认值
        schoolLimit.value = props.studentData.school_quota_num
        communityLimit.value = props.studentData.quota_num
        // console.log('studentData', props.studentData)
    }
})

const handleConfirm = async () => {

    try {
        // 直接调用API设置每日限购
        const params = {
            name: props.studentData.name,
            school_quota_num: parseInt(schoolLimit.value),
            quota_num: parseInt(communityLimit.value),
            quote_type: '修改限购',
        }
        const reqUrl = props.studentData.from_page === 'profile-completion' ? '/api/update/partner/info' : '/api/add/child/student'
        if (props.studentData.from_page === 'profile-completion') {
            params.partner_id = props.studentData.id
        }else{
            params.partner_id = parseInt(localStorage.getItem('userId'))
            params.student_id = props.studentData.id
        }
        const res = await post(reqUrl, params)
        
        if (res.result && res.result.state === 'ok') {
            Toast.success('设置成功')
            emit('submit', { school_quota_num: parseInt(schoolLimit.value), quota_num: parseInt(communityLimit.value) })
            emit('update:show', false)
        } else {
            Toast.fail(res.result?.message || '设置失败')
        }
    } catch (error) {
        console.error('设置每日限购失败:', error)
        Toast.fail('网络错误，请重试')
    }
}

const handleCancel = () => {
    emit('update:show', false)
}

const handleUpdateShow = (value) => {
    emit('update:show', value)
}
</script>

<style scoped>
.daily-limit-modal {
    padding: 21px 0;
    background: #fff;
}

.modal-header {
    padding: 0 21px;
    margin-bottom: 21px;
}

.modal-title {
    font-size: 16px;
    font-weight: 500;
    color: #000;
}

.modal-content {
    padding: 0 21px;
}

.description {
    font-size: 14px;
    color: #666;
    margin-bottom: 20px;
    line-height: 1.4;
}

.form-container {
    margin-bottom: 20px;
}

/* 表单项样式 */
.form-item {
    margin-bottom: 13px;
}

.form-label {
    font-size: 12px;
    color: #4B5563;
    margin-bottom: 5px;
}

/* 自定义字段样式 */
:deep(.custom-field) {
    padding: 0;
    background: transparent;
}

:deep(.custom-field .van-field__control) {
    padding: 5px 10px;
    border: 1px solid rgba(229, 231, 235, 1);
    border-radius: 7px;
    font-size: 12px;
    color: #333;
}

:deep(.custom-field .van-field__control:focus) {
    border-color: var(--van-primary-color);
    background: #fff;
}

:deep(.custom-field .van-field__control::placeholder) {
    color: #6B7280;
}

.modal-actions {
    display: flex;
    gap: 12px;
}

.cancel-btn {
    flex: 1;
    background: #f5f5f5;
    border: none;
    color: #4B5563;
    border-radius: 4px;
    height: 38px;
    font-size: 14px;
}

.confirm-btn {
    flex: 1;
    border: none;
    color: #fff;
    border-radius: 4px;
    height: 38px;
    font-size: 14px;
}

/* 选择器样式 */
:deep(.van-popup) {
    border-radius: 12px;
}
</style>
